module.exports = __webpack_public_path__ + "static/media/Plenary.a4bd4568.jpg";